import React from "react";
import ProjectItem from "../ProjectItem";

const ProjectWrapperTwoRows = ({ projectsWrapper, path="projects" }) => {
	const [projectFirst, projectSecond, projectThird] = projectsWrapper;

	return (
		<div className="projects-list__wrapper">
			<div className="projects-list__item">
				<ProjectItem
					path={path}
					title={projectFirst.title}
					slug={projectFirst.slug}
					technologies={projectFirst.technologies}
					squaredImage={projectFirst.acfProject?.squaredImage || projectFirst.acfTheme?.squaredImage }
				/>
			</div>

			{projectSecond && (
				<div className="projects-list__item">
					<ProjectItem
						path={path}
						title={projectSecond.title}
						slug={projectSecond.slug}
						technologies={projectSecond.technologies}
						squaredImage={projectSecond.acfProject?.squaredImage || projectSecond.acfTheme?.squaredImage}
					/>
				</div>
			)}

			{projectThird && (
				<div className="projects-list__item projects-list__item--fullwidth">
					<ProjectItem
						path={path}
						title={projectThird.title}
						slug={projectThird.slug}
						technologies={projectThird.technologies}
						squaredImage={projectThird.acfProject?.squaredImage || projectThird.acfTheme?.squaredImage}
					/>
				</div>
			)}
		</div>
	);
}

export default ProjectWrapperTwoRows;
